import { render, staticRenderFns } from "./DocumentSeriesTypeListTable.vue?vue&type=template&id=14e0b28a&"
import script from "./DocumentSeriesTypeListTable.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesTypeListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports